<script lang="ts">
    import { DocType } from "$src/domain/projects/documents/DoctType";
    import type { DocumentSummary } from "$src/domain/projects/documents/DocumentSummary";
    import { Image } from 'lucide-svelte';
    import { FileText } from 'lucide-svelte';
    import { Text } from 'lucide-svelte';

    export let document: DocumentSummary
</script>

{#if document.documentType == DocType.Image}
    <Image class="h-5 w-5"/>
{:else if document.documentType == DocType.PDF }
    <FileText class="h-5 w-5"/>
{:else}
    <Text class="h-5 w-5"/>
{/if}

